// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"ed9c96fa097c903f","4095":"99136cea9e621d9c","7715":"701f04ff56c00070"}[chunkId] + ".css";
};